import { Box, HBox, VBox } from "../box/Box";
import { IconUserCheck } from "../icons/IconUserCheck";
import { Typo } from "../text/Typo";

interface ILLinkProps {
	id?: string;
	sx?: React.CSSProperties & { [key: string]: any };
	title?: string;
	subtitle?: string | null;
	name?: string;
	icon?: string | null;
	data?: Record<string, any>;
	value?: any;
	disabled?: boolean;
	size?: "small" | "medium" | "large";
}

export const Link = ({ title, subtitle, size, sx, value, icon }: ILLinkProps) => {
	// const theme = useTheme() as ITheme;
	if (!size) size = "medium";

	const getIcon = (iconName: string) => {
		const iconSize = size === "small" ? 18 : size === "medium" ? 34 : 30;
		switch (iconName) {
			case "user_check":
				return <IconUserCheck size={iconSize} />;

			default:
				return null;
		}
	};

	//!TODO: get icon color;
	return (
		<HBox
			sx={{
				gap: "10px",
				alignItems: "start",
				...sx,
			}}>
			{icon && <Box sx={{ width: "34px", height: "34px" }}>{getIcon(icon)}</Box>}
			<VBox sx={{ gap: "4px", alignItems: "start" }}>
				{title && (
					<Typo
						onClick={() => {
							window.open(value, "_blank", "noopener,noreferrer");
						}}
						color="#336aff"
						sx={{ cursor: "pointer", textDecoration: "underline" }}
						variant="medium">
						{title}
					</Typo>
				)}
				{subtitle && <Typo variant="medium">{subtitle}</Typo>}
			</VBox>
		</HBox>
	);
};
